import taskInstancesHeaderButtonsUrl from './taskInstancesHeaderButtons.html';

class TaskInstancesHeaderButtonsCtrl {
  constructor(ShiftTasksService, $scope) {
    'ngInject';

    Object.assign(this, { ShiftTasksService, $scope });

    this.query = this.ShiftTasksService.query;
  }

  $onInit() {
    this.typingWatcher = this.$scope.$watch('ctrl.query', (query, prevQuery) => {
      if (query !== prevQuery) {
        this.searchWithinTaskInstances(query);
      }
    });
  }

  $onDestroy() {
    this.ShiftTasksService.clearSearchQuery();
    this.typingWatcher?.();
  }

  searchWithinTaskInstances(searchText) {
    this.ShiftTasksService.search(searchText);
  }

  get isFeatureAvailable() {
    return this.ShiftTasksService.isFeatureEnabled;
  }
}

export default {
  templateUrl: taskInstancesHeaderButtonsUrl,
  controller: TaskInstancesHeaderButtonsCtrl,
  controllerAs: 'ctrl',
};
